import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ShowroundModalState,
  ShowroundsAnalyticsContext,
  ShowroundSupplier,
} from '@bridebook/web/lib/showrounds/types/types';
import { EnquiriesActionTypes } from '@bridebook/web/lib/enquiries/action-types';

export const showroundModalInitialState: ShowroundModalState = {
  isOpen: false,
  calendarIdFromUrl: null,
  supplierContext: null,
  analyticsContext: {
    actionLocation: '',
    actionSection: '',
  },
  defaultDate: null,
};

interface OpenShowroundModalPayload {
  calendarIdFromUrl?: string | null;
  supplier: ShowroundSupplier;
  analyticsContext: ShowroundsAnalyticsContext;
  defaultDate?: string | null;
}

const showroundSlice = createSlice({
  name: 'showround',
  initialState: showroundModalInitialState,
  reducers: {
    openShowroundModal: (state, action: PayloadAction<OpenShowroundModalPayload | undefined>) => {
      state.isOpen = true;
      state.calendarIdFromUrl = action.payload?.calendarIdFromUrl;
      state.supplierContext = action.payload?.supplier ?? null;
      state.analyticsContext =
        action.payload?.analyticsContext ?? showroundModalInitialState.analyticsContext;
      state.defaultDate = action.payload?.defaultDate ?? null;
    },
    setShowroundAnalyticsContext: (state, action: PayloadAction<ShowroundsAnalyticsContext>) => {
      state.analyticsContext = action.payload;
    },
    closeShowroundModal: (state) => {
      state.isOpen = false;
      state.calendarIdFromUrl = null;
      state.supplierContext = null;
      state.analyticsContext = showroundModalInitialState.analyticsContext;
      state.defaultDate = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) =>
        action.type === EnquiriesActionTypes.SEND_ENQUIRY_SUCCESS ||
        action.type === EnquiriesActionTypes.SEND_ENQUIRY_ERROR,
      (state) => {
        // Close the modal when the enquiry completes
        if (state.isOpen) {
          state.isOpen = false;
          state.calendarIdFromUrl = null;
          state.supplierContext = null;
          state.analyticsContext = showroundModalInitialState.analyticsContext;
          state.defaultDate = null;
        }
      },
    );
  },
});

export const { openShowroundModal, closeShowroundModal, setShowroundAnalyticsContext } =
  showroundSlice.actions;
export default showroundSlice.reducer;
